import request from '@/auth/jwt/request'

/**
 * @description 客户留言 -- 客户留言列表
 * @param {Object} param params {Object} 传值参数
 */
export const feedbackListApi = params => { return request('leave-words/list', 'get', params) }
